class JumpNavigation extends HTMLElement {
  constructor() {
    super();

    gsap.registerPlugin(ScrollToPlugin);

    this.stickyHeader = document.querySelector('sticky-header');
    this.header = document.querySelector('.section-header');
    this.menuItems = Array.from(this.querySelectorAll('[data-nav-link]'));
    this.firstTarget = document.querySelector(this.menuItems[0].getAttribute('href'));
    this.scrollOffset = `${parseInt(this.header.getBoundingClientRect().bottom)}`;
    this.activeItem = null;
    this.positions = {};
    this.isNavigating = false;

    this.handleItemClick = this.onItemClick.bind(this);
    this.handleLoad = this.onLoad.bind(this);
  }

  connectedCallback() {
    this.menuItems.forEach(item => item.addEventListener('click', this.handleItemClick));
    window.addEventListener('load', this.handleLoad);
  }

  disconnectedCallback() {
    this.menuItems.forEach(item => item.removeEventListener('click', this.handleItemClick));
    window.removeEventListener('load', this.handleLoad);
    this.observer?.disconnect();
  }

  onLoad() {
    this.setPositions();
    // this.createObserver();
  }

  setPositions() {
    this.menuItems.forEach(item => {
      const target = document.querySelector(item.getAttribute('href'));

      if (target) {
        const { offsetTop, offsetHeight } = target;
        const intersectionRatio = this.getVisibility(target);

        this.positions[target.id] = {
          target,
          intersectionRatio,
          offsetTop,
          offsetHeight,
        };
      }
    });
  }

  getVisibility(element) {  
    const viewportHeight = window.innerHeight;
    const viewportTop = window.scrollY;
    const viewportBottom = viewportTop + viewportHeight;

    const elementHeight = element.offsetHeight;
    const elementTop = element.offsetTop;
    const elementBottom = elementTop + elementHeight;

    const visibleTop = Math.max(viewportTop, elementTop);
    const visibleBottom = Math.min(viewportBottom, elementBottom);
    return clamp(0, (visibleBottom - visibleTop) / elementHeight, 1);
  }

  createObserver() {
    this.observer = new IntersectionObserver((entries, observer) => {      
      this.setPositions();

      const visibleItems = Object.values(this.positions).filter(item => item.intersectionRatio >= 0.8).sort((a, b) => a.target.offsetTop - b.target.offsetTop);

      if (!this.isNavigating) {
        this.setActiveItem(visibleItems[0]?.target.id);
      }

    }, { threshold: [0, 0.2, 0.4, 0.6, 0.8, 1] });

    this.menuItems.forEach(item => {
      const target = document.querySelector(item.getAttribute('href'));

      if (target) {
        this.observer.observe(target);
      }
    });
  }

  getItemByHash(hash) {
    return this.menuItems.find(item => item.hash === hash);
  }

  updateHash(activeHash) {
    if (activeHash[0] !== '#') activeHash = `#${activeHash}`;
    history.pushState({}, '', activeHash);
  }

  setActiveItem(activeItem) {
    if (!activeItem) return;

    if (typeof activeItem === 'string') {
      activeItem = this.getItemByHash(`#${activeItem}`);
    }

    if (!activeItem || activeItem == this.activeItem) return;

    this.activeItem = activeItem;
    this.menuItems.forEach(item => item.classList.remove('is-active'));
    this.activeItem.classList.add('is-active');

    this.updateHash(this.activeItem.hash);
  }

  onItemClick(e) {
    e.preventDefault();
    const anchor = e.currentTarget.getAttribute('href');
    const anchorEl = document.querySelector(anchor);

    if (!anchorEl) {
      console.error('Jump Navigation: Corresponding section not found');
      return false;
    }

    // Remove 1px offset for the first item to prevent top border from showing
    let offsetY = (e.currentTarget === this.menuItems[0]) ? this.scrollOffset : this.scrollOffset;

    // Calculate scroll duration based on distance to target
    const distance = Math.abs((anchorEl.offsetTop - offsetY) - window.scrollY);
    // Clamp duration to prevent scrolling too fast or slow
    const duration = clamp(300, distance, 1200) / 1000;

    this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    this.setActiveItem(e.currentTarget);
    this.isNavigating = true;

    gsap.to(window, {
      ease: 'power2.inOut',
      duration,
      scrollTo: {
        y: anchor,
        offsetY,
      },
      onComplete: () => this.isNavigating = false
    });
  }
}

customElements.define('jump-navigation', JumpNavigation);